/* eslint-disable no-bitwise */
/* eslint-disable prefer-destructuring */
import $ from 'jquery';

class Utilities {
  getMaxHeight(element, includeMargin = false) {
    this.heights = $(element).map((i, el) => $(el).outerHeight(includeMargin));

    return Math.max(...this.heights);
  }

  lightOrDark(color) {
    this.color = color;
    let r = null;
    let g = null;
    let b = null;
    // Check the format of the color, HEX or RGB?
    if (this.color.match(/^rgb/)) {
      // If HEX --> store the red, green, blue values in separate variables
      this.color = this.color.match(
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/,
      );

      r = this.color[1];
      g = this.color[2];
      b = this.color[3];
    } else {
      // If RGB --> Convert it to HEX: http://gist.github.com/983661
      this.color = +`0x${this.color
        .slice(1)
        .replace(this.color.length < 5 && /./g, '$&$&')}`;

      r = this.color >> 16;
      g = (this.color >> 8) & 255;
      b = this.color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
      return 'light';
    }

    return 'dark';
  }

  isInView(element, offset = 50) {
    this.topOffset = $(window).scrollTop();
    this.windowHeight = $(window).height();

    const inView =
      $(element).offset().top <= this.topOffset + this.windowHeight - offset;

    return inView;
  }
}

export default Utilities;



// WEBPACK FOOTER //
// ./src/scripts/modules/utilities.js